export const dealerListNames = (arr = []) => {
  const dealers = arr.slice(1, arr.length);
  const idxTTE = dealers.length - 2;
  return [
    ...dealers.slice(0, idxTTE),
    {'text': 'TOTAL OBJETIVO', 'value': '123456789', 'alias': 'TOTAL'},
    ...dealers.slice(idxTTE, dealers.length),
  ];
};
